import React, { FC, ReactElement } from 'react';

import { Flex, Typography } from 'antd';

const { Text } = Typography;

interface IInputWithLabelProps {
	id: string;
	label?: string;
	error?: string;
	input: ReactElement;
	maxWidth?: string;
}

const InputWithLabel: FC<IInputWithLabelProps> = ({ id, label, input, error, maxWidth }) => (
	<Flex vertical className='form-item__wrapper w-full' style={{ maxWidth: maxWidth || 370 }}>
		{label && <label htmlFor={id}>{label}</label>}
		{input}
		{error && <Text className='description text-red'>{error}</Text>}
	</Flex>
);

export default InputWithLabel;
